import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import MobileHandoffPage from "../pages/mobile-handoff/page";
import ActivityCheckinPage from "../pages/activity-checkin/page";
import AdminPage from "../pages/admin/page";
import AdminLogin from "../pages/admin/login";
import PlatformPage from "../pages/platform/page";
import PlatformLogin from "../pages/platform/login";

/** 会员端 H5/小程序已迁至 `Football-mobile`（Taro）；此处仅保留跳转说明 */
const routes: RouteObject[] = [
  { path: "/", element: <MobileHandoffPage /> },
  { path: "/home", element: <MobileHandoffPage /> },
  { path: "/fan-interaction", element: <MobileHandoffPage /> },
  { path: "/member-services", element: <MobileHandoffPage /> },
  { path: "/member-services/login", element: <MobileHandoffPage /> },
  { path: "/member-services/register", element: <MobileHandoffPage /> },
  { path: "/activities", element: <MobileHandoffPage /> },
  { path: "/votes", element: <MobileHandoffPage /> },
  { path: "/admin/login", element: <AdminLogin /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/platform/login", element: <PlatformLogin /> },
  { path: "/platform", element: <PlatformPage /> },
  { path: "/activity-checkin/:activityId", element: <ActivityCheckinPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
